import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-main-catalog-materials',
    templateUrl: './main-catalog-materials.component.html',
    styleUrls: ['./main-catalog-materials.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainCatalogMaterialsComponent implements OnInit {
    AppScope = AppScope;
    constructor() {}

    ngOnInit(): void {}
}
